module.exports = __webpack_public_path__ + "770cd9e8afd03dc95944feda118c415b.pdf";